<template>
    <div></div>
</template>

<script>
export default {
    name: 'CookieConsentBox',
    data: function(){
        return {
            contentText: this.$t('cookie-consent.content-text'),
            layoutClass: 'cookie--banner-layout-2',
            contentHeadline: this.$t('cookie-consent.headline'),
            additionalCookies: [
                {
                    "mainGroup" : this.$t('cookie-consent.group.analytics'),
                    "cookieGroup": "Google Analytics",
                    "cookies": [
                        {
                            "name": "_ga",
                            "expiration": `2 ${this.$t("time.years")}`,
                            "description": this.$t('cookie-consent.cookies._ga'),
                            "provider": "Google"
                        },
                        {
                            "name": "_gid",
                            "expiration": `1 ${this.$t("time.day")}`,
                            "description": this.$t('cookie-consent.cookies._gid'),
                            "provider": "Google"
                        }
                    ]
                },
                {
                    "mainGroup" : this.$t('cookie-consent.group.optional-functionalities'),
                    "cookieGroup": "Optional Functionalities",
                    "cookies": [
                        {
                            "name": "Delivery cost calculator",
                            "expiration": `1 ${this.$t("time.years")}`,
                            "description": this.$t('cookie-consent.cookies.delivery-cost-calculator'),
                            "provider": "FAAREN"
                        },
                    ]
                }
            ],
            additionalGroups: {
                "0": {
                    "name": this.$t('cookie-consent.group.required'),
                    "mandatory": true,
                    "cookie_groups": {
                        "0": {
                            "name": this.$t('cookie-consent.group.cookie-consent'),
                            "cookies": {
                                "cookie_config": {
                                    "expiration": `1 ${this.$t("time.year")}`,
                                    "description": this.$t('cookie-consent.cookies.cookie_config'),
                                    "provider": "FAAREN"
                                },
                                "__stripe_sid": {
                                    "expiration": `30 ${this.$t("time.minutes")}`,
                                    "description": this.$t('cookie-consent.cookies.stripe'),
                                    "provider": "STRIPE"
                                },
                                "__stripe_mid": {
                                    "expiration": `1 ${this.$t("time.year")}`,
                                    "description": this.$t('cookie-consent.cookies.stripe'),
                                    "provider": "STRIPE"
                                },
                            }
                        }
                    }
                },
                "1": {
                    "name": this.$t('cookie-consent.group.functional'),
                    "mandatory": true,
                    "cookie_groups": {
                        "0": {
                            "name": this.$t('cookie-consent.group.payment-provider'),
                            "cookies": {
                                "faaren_frontend_service_session": {
                                    "expiration": `2 ${this.$t("time.hours")}`,
                                    "description": this.$t('cookie-consent.cookies.faaren_frontend_service_session'),
                                    "provider": "FAAREN"
                                },
                                "locale": {
                                    "expiration": this.$t('cookie-consent.cookies.session'),
                                    "description": this.$t('cookie-consent.cookies.locale'),
                                    "provider": "FAAREN"
                                }
                            }
                        },
                        "1": {
                            "name": this.$t('cookie-consent.group.webpage'),
                            "cookies": {
                                "faaren_frontend_service_session": {
                                    "expiration": `2 ${this.$t("time.hours")}`,
                                    "description": this.$t('cookie-consent.cookies.faaren_frontend_service_session'),
                                    "provider": "FAAREN"
                                },
                                "locale": {
                                    "expiration": this.$t('cookie-consent.cookies.session'),
                                    "description": this.$t('cookie-consent.cookies.locale'),
                                    "provider": "FAAREN"
                                },
                                "XSRF-TOKEN": {
                                    "expiration": this.$t('cookie-consent.cookies.session'),
                                    "description": this.$t('cookie-consent.cookies.XSRF-TOKEN'),
                                    "provider": "FAAREN"
                                },
                                "Google Storage": {
                                    "expiration": this.$t('cookie-consent.cookies.session'),
                                    "description": this.$t('cookie-consent.cookies.google-storage'),
                                    "provider": "FAAREN"
                                },
                            }
                        }
                    }
                }
            },
        }
    },
    methods: {
        handleScript(){
            var i;
            var n;
            function handleBtnCheckAllCookies() {
                var checkboxes = document.querySelectorAll("[data-cookie-checkbox-top-group-name]");
                var allChecked = true;
                for (i = 0, n = checkboxes.length; i < n; i++) {
                    if (allChecked === true && checkboxes[i].checked === false) {
                        allChecked = false;
                    }
                    checkboxes[i].checked = true;
                }
                setCookieForCookieConfig();
                var timeout = 400;
                if (allChecked) {
                    timeout = 0;
                }
                setTimeout(function () {
                    document.getElementById("cookieBanner").setAttribute("style", "display: none !important");
                    document.getElementById("containerCookieBanner").setAttribute("style", "display: none !important");
                document.body.classList.remove("overflow-hidden");
                }, timeout);
            }
            function setCookieForCookieConfig() {
                var currentCookieGroups = getCookie("cookie_config");
                var checkboxes = document.querySelectorAll('[data-cookie-checkbox-middle-group="true"]');
                var cookieGroups = [];
                for (i = 0, n = checkboxes.length; i < n; i++) {
                    if (checkboxes[i].checked) {
                        cookieGroups.push(checkboxes[i].getAttribute("data-cookie-checkbox-middle-group-name"));
                    }
                }
                setCookie("cookie_config", JSON.stringify(cookieGroups), 360);
                handleScriptsDependingOnCookieConfig(cookieGroups);
                if (typeof logUserCookieChoice === "function") {
                    logUserCookieChoice(cookieGroups);
                }
                if (currentCookieGroups !== null && currentCookieGroups !== JSON.stringify(cookieGroups)) {
                    window.location.reload();
                }
            }
            function handleScriptsDependingOnCookieConfig(cookieGroups) {
                if (!cookieGroups) {
                    cookieGroups = getCookie("cookie_config");
                    if (cookieGroups === null) {
                        return;
                    }
                    cookieGroups = JSON.parse(cookieGroups);
                }
                var acceptedCookies = [];
                for (var cookieGroupsCount = 0, n1 = cookieGroups.length; cookieGroupsCount < n1; cookieGroupsCount++) {
                    var scriptTagNodes = document.querySelectorAll('[data-cookie-group="' + cookieGroups[cookieGroupsCount] + '"]');
                    for (var scriptTagNodesCount = 0, n2 = scriptTagNodes.length; scriptTagNodesCount < n2; scriptTagNodesCount++) {
                        var cookieName = scriptTagNodes[scriptTagNodesCount].getAttribute("data-cookie-name");
                        acceptedCookies.push(cookieName);
                        var cloneExists = document.querySelectorAll('[data-clone-cookie-name="' + cookieName + '"]');
                        if (cloneExists.length === 0) {
                            var clone = document.createElement("script");
                            clone.innerHTML = scriptTagNodes[scriptTagNodesCount].innerHTML;
                            clone.type = "text/javascript";
                            clone.setAttribute("data-clone-cookie-name", cookieName);
                            if (scriptTagNodes[scriptTagNodesCount].src) {
                                clone.src = scriptTagNodes[scriptTagNodesCount].src;
                            }
                            document.body.appendChild(clone);
                        }
                    }
                }
                var allCookies = document.querySelectorAll("[data-cookie-name]");
                for (i = 0, n = allCookies.length; i < n; i++) {
                    cookieName = allCookies[i].getAttribute("data-cookie-name");
                    if (acceptedCookies.indexOf(cookieName) === -1) {
                        var cookieDomain = allCookies[i].getAttribute("data-cookie-domain");
                        eraseCookie(cookieName, "/", cookieDomain);
                    }
                }
                var sendDataLayerEventInterval = setInterval(sendDataLayerEvent, 500);
                var dataLayerEventIntervalCounter = 0;
                function sendDataLayerEvent() {
                    dataLayerEventIntervalCounter++;
                    if (window.google_tag_manager) {
                        cookies = {};
                        var checkboxes = document.querySelectorAll('[data-cookie-checkbox-middle-group="true"]');
                        for (i = 0, n = checkboxes.length; i < n; i++) {
                            cookies[checkboxes[i].dataset.cookieCheckboxMiddleGroupName] = checkboxes[i].checked;
                        }
                        dataLayer.push({ event: "mws_consent_initialized", cookie_config: cookies });
                        clearInterval(sendDataLayerEventInterval);
                    }
                    if (dataLayerEventIntervalCounter === 15) clearInterval(sendDataLayerEventInterval);
                }
            }
            function initialCheckDependingOnCookieConfig() {
                var cookieGroups = getCookie("cookie_config");
                if (cookieGroups === null) {
                    document.getElementById("cookieBanner").setAttribute("style", "display: block !important");
                    document.getElementById("containerCookieBanner").setAttribute("style", "display: block !important");
                    document.body.classList.add("overflow-hidden");
                    return;
                }
                cookieGroups = JSON.parse(cookieGroups);
                for (var i = 0, n1 = cookieGroups.length; i < n1; i++) {
                    var cookieGroupCheckboxes = document.querySelectorAll('[data-cookie-checkbox-middle-group="true"][data-cookie-checkbox-middle-group-name="' + cookieGroups[i] + '"]');
                    for (var cookieGroupCheckboxesCount = 0, n2 = cookieGroupCheckboxes.length; cookieGroupCheckboxesCount < n2; cookieGroupCheckboxesCount++) {
                        cookieGroupCheckboxes[cookieGroupCheckboxesCount].checked = true;
                        var cookieCheckboxes = document.querySelectorAll('[data-cookie-checkbox-low-group="true"][data-cookie-checkbox-middle-group-name="' + cookieGroups[i] + '"]');
                        for (var cookieCheckboxesCount = 0, n3 = cookieCheckboxes.length; cookieCheckboxesCount < n3; cookieCheckboxesCount++) {
                            cookieCheckboxes[cookieCheckboxesCount].checked = true;
                        }
                        checkWhetherAllCookieGroupsOfCookieMainGroupAreChecked(cookieGroupCheckboxes[cookieGroupCheckboxesCount].getAttribute("data-cookie-checkbox-top-group-name"));
                    }
                }
            }
            function checkWhetherAllCookieGroupsOfCookieMainGroupAreChecked(cookieMainGroup) {
                var checkboxes = document.querySelectorAll('[data-cookie-checkbox-middle-group="true"][data-cookie-checkbox-top-group-name="' + cookieMainGroup + '"]');
                var allChecked = true;
                for (i = 0, n = checkboxes.length; i < n; i++) {
                    if (!checkboxes[i].checked) {
                        allChecked = false;
                        return false;
                    }
                }
                if (allChecked) {
                    var checkboxes = document.querySelectorAll('[data-cookie-checkbox-top-group="true"][data-cookie-checkbox-top-group-name="' + cookieMainGroup + '"]');
                    for (i = 0, n = checkboxes.length; i < n; i++) {
                        checkboxes[i].checked = true;
                    }
                }
            }
            function generateCookieMainGroupHeaderTopHtml(cookieMainGroup, mandatory) {
                if (mandatory) {
                    return (
                        '<label class="checkbox--wrapper first">\n' +
                        '                    <input type="checkbox" checked="checked" onclick="return false;" disabled data-cookie-checkbox-top-group="true" data-cookie-checkbox-top-group-name="' +
                        cookieMainGroup.toLowerCase() +
                        '">\n' +
                        '                    <span class="checkmark"></span>\n' +
                        '                    <p class="cookie--category-element">\n' +
                        "                        " +
                        cookieMainGroup +
                        "</p>\n" +
                        "                </label>"
                    );
                }
                return (
                    '<label class="checkbox--wrapper">\n' +
                    '                    <input type="checkbox" data-cookie-checkbox-top-group="true" data-cookie-checkbox-top-group-name="' +
                    cookieMainGroup.toLowerCase() +
                    '">\n' +
                    '                    <span class="checkmark"></span>\n' +
                    '                    <p class="cookie--category-element">' +
                    cookieMainGroup +
                    "</p>\n" +
                    "                </label>"
                );
            }
            function generateCookieMainGroupHeaderHtml(cookieMainGroup, mandatory, checked) {
                var checkedHtml = "";
                if (checked || mandatory) {
                    checkedHtml = 'checked="checked"';
                }
                var mandatoryHtml = "";
                if (mandatory) {
                    mandatoryHtml = 'onclick="return false;" disabled';
                }
                return (
                    '<div class="cookie--heading">\n' +
                    '                            <label class="checkbox--wrapper">\n' +
                    '                                <input type="checkbox" ' +
                    checkedHtml +
                    " " +
                    mandatoryHtml +
                    ' data-cookie-checkbox-top-group="true" data-cookie-checkbox-top-group-name="' +
                    cookieMainGroup.toLowerCase() +
                    '">\n' +
                    '                                <span class="checkmark"></span>\n' +
                    '                                <p class="heading--category">\n' +
                    "                                    " +
                    cookieMainGroup +
                    "</p>\n" +
                    "                            </label>\n" +
                    "                        </div>"
                );
            }
            function generateCookieGroupHeaderHtml(cookieMainGroup, cookieGroup, mandatory, checked) {
                var checkedHtml = "";
                if (checked || mandatory) {
                    checkedHtml = 'checked="checked"';
                }
                var mandatoryHtml = "";
                if (mandatory) {
                    mandatoryHtml = 'onclick="return false;" disabled';
                }
                return (
                    '<div class="container--cookie-category">\n' +
                    '                                <label class="checkbox--wrapper">\n' +
                    '                                    <input type="checkbox" ' +
                    checkedHtml +
                    " " +
                    mandatoryHtml +
                    ' data-cookie-checkbox-middle-group="true" data-cookie-checkbox-middle-group-name="' +
                    cookieGroup +
                    '" data-cookie-checkbox-top-group-name="' +
                    cookieMainGroup.toLowerCase() +
                    '">\n' +
                    '                                    <span class="checkmark"></span>\n' +
                    '                                    <p class="cookie--main-heading">\n' +
                    "                                        " +
                    cookieGroup +
                    "</p>\n" +
                    "                                </label>\n" +
                    "                            </div>"
                );
            }
            function generateCookieTableHtml(cookieMainGroup, cookieGroup, cookieName, cookieDescription, cookieProvider, cookieExpires, mandatory, checked) {
                var checkedHtml = "";
                if (checked || mandatory) {
                    checkedHtml = 'checked="checked"';
                }
                return (
                    "<tr>\n" +
                    "                                    <td>\n" +
                    '                                        <label class="checkbox--wrapper">\n' +
                    '                                            <input type="checkbox" ' +
                    checkedHtml +
                    ' onclick="return false;" data-cookie-checkbox-low-group="true" data-cookie-checkbox-middle-group-name="' +
                    cookieGroup +
                    '" data-cookie-checkbox-top-group-name="' +
                    cookieMainGroup.toLowerCase() +
                    '">\n' +
                    '                                            <span class="checkmark"></span>\n' +
                    "                                        </label>\n" +
                    "                                    </td>\n" +
                    '                                    <td width="150">\n' +
                    "                                        <p>Name</p>\n" +
                    "                                        <p>" +
                    cookieName +
                    "</p>\n" +
                    "                                    </td>\n" +
                    "                                    <td>\n" +
                    "                                        <p>Laufzeit</p>\n" +
                    "                                        <p>" +
                    cookieExpires +
                    "</p>\n" +
                    "                                    </td>\n" +
                    "                                    <td>\n" +
                    "                                        <p>Beschreibung</p>\n" +
                    "                                        <p>" +
                    cookieDescription +
                    "</p>\n" +
                    "                                    </td>\n" +
                    "                                    <td>\n" +
                    "                                        <p>Herausgeber</p>\n" +
                    "                                        <p>" +
                    cookieProvider +
                    "</p>\n" +
                    "                                    </td>\n" +
                    "                                </tr>"
                );
            }
            function setCookie(name, value, days) {
                var expires = "";
                if (days) {
                    var date = new Date();
                    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3);
                    expires = "; expires=" + date.toUTCString();
                }
                document.cookie = name + "=" + (value || "") + expires + "; path=/";
            }
            function getCookie(name) {
                var nameEQ = name + "=";
                var ca = document.cookie.split(";");
                for (i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == " ") c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            }
            function eraseCookie(name, path, domain) {
                document.cookie = encodeURIComponent(name) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (domain ? "; domain=" + domain : "") + (path ? "; path=" + path : "");
            }
            handleScriptsDependingOnCookieConfig(false);
            var cookieConfigPath = "/js/mws-cookie-solution-config.json";
            var cookieScriptTagElement = document.querySelector("[data-cookie-config-path]");
            if (cookieScriptTagElement !== null) {
                cookieConfigPath = cookieScriptTagElement.getAttribute("data-cookie-config-path");
            }

            if (window.location.hash.substr(1) === "disableCookieBanner") {
                return;
            }

            var cookieHtmlScaffold =
                '<div class="container--cookie-banner" id="containerCookieBanner">\n' +
                '    <div id="cookieBanner" class="cookie--banner ' +
                this.layoutClass +
                '">\n' +
                '        <div class="cookie--overlay">\n' +
                '            <p class="cookie--main-heading">\n' +
                "                " +
                this.contentHeadline +
                "</p>\n" +
                '            <div class="cookie--text-container">\n' +
                '               <p class="cookie--text">\n' +
                "                  " +
                this.contentText +
                "\n" +
                "               </p>\n" +
                '               <button class="cookie--text-collapsible">'+this.$t('cookie-consent.show-more')+'</button>\n' +
                "           </div>\n" +
                '            <div id= "container-groups" class="container--checkboxes">\n' +
                "            </div>\n" +
                "            <div>\n" +
                '                <button class="cookie--collapsible" type="button">\n' +
                "                    <p>"+this.$t('cookie-consent.more-information')+"</p>\n" +
                '                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"\n' +
                '                         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
                '                         width="12px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;"\n' +
                '                         xml:space="preserve">\n' +
                "                    <g>\n" +
                '                        <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441\n' +
                "                            L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082\n" +
                "                            c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647\n" +
                '                            c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z"/>\n' +
                "                    </g>\n" +
                "                </svg>\n" +
                "                </button>\n" +
                '                <div id="cookie-content" class="mws-cookie-content-class">\n' +
                "                </div>\n" +
                "            </div>\n" +
                '            <div class="cookie--buttons">\n' +
                '                <button id="btnCurrentCookies" class="btn btn-secondary">'+this.$t('cookie-consent.button.add')+'</button>\n' +
                '                <button id="btnAllCookies" class="btn btn-primary" type="button">'+this.$t('cookie-consent.button.add-all')+'</button>\n' +
                "            </div>\n" +
                "        </div>\n" +
                "    </div>\n" +
                "\n" +
                "</div>";
            document.body.classList.add("container--cookie");
            if(!document.getElementById("containerCookieBanner")) {
                document.body.insertAdjacentHTML("afterbegin", cookieHtmlScaffold);
            }
            var scriptTagNodes = document.querySelectorAll("[data-cookie-main-group]");
            var cookieMainGroups = {};
            for (i = 0, n = scriptTagNodes.length; i < n; i++) {
                var cookieMainGroup = scriptTagNodes[i].getAttribute("data-cookie-main-group");
                if (typeof cookieMainGroups[cookieMainGroup] === "undefined") {
                    cookieMainGroups[cookieMainGroup] = cookieMainGroup.charAt(0).toUpperCase() + cookieMainGroup.slice(1);
                }
            }

            for (var [key, value] of this.additionalCookies.map((aC) => {
                var mainGroup = aC.mainGroup;
                return [mainGroup, mainGroup.charAt(0).toUpperCase() + mainGroup.slice(1)];
            })) {
                if (!cookieMainGroups[key]) cookieMainGroups[key] = value;
            }
            
            var cookieHtml = "";
            for (var cookieMainGroupKey in cookieMainGroups) {
                document.getElementById("container-groups").innerHTML = generateCookieMainGroupHeaderTopHtml(cookieMainGroups[cookieMainGroupKey], false) + document.getElementById("container-groups").innerHTML;
                var scriptTagNodesByCookieMainGroup = document.querySelectorAll('[data-cookie-main-group="' + cookieMainGroupKey + '"]');
                var cookieMainGroupHeaderHtml = generateCookieMainGroupHeaderHtml(cookieMainGroups[cookieMainGroupKey], false, false);
                var cookieGroups = {};
                for (i = 0, n = scriptTagNodesByCookieMainGroup.length; i < n; i++) {
                    var cookieGroup = scriptTagNodesByCookieMainGroup[i].getAttribute("data-cookie-group");
                    if (typeof cookieGroups[cookieGroup] === "undefined") {
                        cookieGroups[cookieGroup] = cookieGroup;
                    }
                }
                this.additionalCookies.forEach((aC) => {
                    if (aC.mainGroup == cookieMainGroupKey) {
                        if (!cookieGroups[aC.cookieGroup]) cookieGroups[aC.cookieGroup] = aC.cookieGroup;
                    }
                });
                var cookieBodyHtml = "";
                for (var cookieGroupKey in cookieGroups) {
                    var cookieGroupHeaderHtml = generateCookieGroupHeaderHtml(cookieMainGroups[cookieMainGroupKey], cookieGroups[cookieGroupKey], false, false);
                    var cookieTableHtml = "";
                    var scriptTagNodesByCookieGroup = document.querySelectorAll('[data-cookie-group="' + cookieGroups[cookieGroupKey] + '"]');
                    for (i = 0, n = scriptTagNodesByCookieGroup.length; i < n; i++) {
                        cookieTableHtml += generateCookieTableHtml(
                            cookieMainGroups[cookieMainGroupKey],
                            cookieGroups[cookieGroupKey],
                            scriptTagNodesByCookieGroup[i].getAttribute("data-cookie-name"),
                            scriptTagNodesByCookieGroup[i].getAttribute("data-cookie-description"),
                            scriptTagNodesByCookieGroup[i].getAttribute("data-cookie-provider"),
                            scriptTagNodesByCookieGroup[i].getAttribute("data-cookie-expiration"),
                            false
                        );
                    }
                    this.additionalCookies.forEach((aC) => {
                        if (aC.cookieGroup == cookieGroupKey) {
                            aC.cookies.forEach((cookie) => {
                                cookieTableHtml += generateCookieTableHtml(cookieMainGroups[cookieMainGroupKey], cookieGroups[cookieGroupKey], cookie.name, cookie.description, cookie.provider, cookie.expiration, false);
                            });
                        }
                    });

                    cookieBodyHtml += '<div class="container--table">' + cookieGroupHeaderHtml + "<table>" + cookieTableHtml + "</table></div>";
                }
                cookieHtml += "<div>" + cookieMainGroupHeaderHtml + cookieBodyHtml + "</div>";
            }
            var additionalCookieMainGroups = this.additionalGroups;
            var additionalCookieHtml = "";
            for (cookieMainGroupKey in additionalCookieMainGroups) {
                var cookieMainGroupMandatory = additionalCookieMainGroups[cookieMainGroupKey].mandatory;
                document.getElementById("container-groups").innerHTML =
                    generateCookieMainGroupHeaderTopHtml(additionalCookieMainGroups[cookieMainGroupKey].name, cookieMainGroupMandatory) + document.getElementById("container-groups").innerHTML;
                var cookieMainGroupHeaderHtml = generateCookieMainGroupHeaderHtml(additionalCookieMainGroups[cookieMainGroupKey].name, cookieMainGroupMandatory, false);
                var cookieBodyHtml = "";
                var cookieGroups = additionalCookieMainGroups[cookieMainGroupKey].cookie_groups;
                for (var cookieGroupKey in cookieGroups) {
                    var cookieGroupHeaderHtml = generateCookieGroupHeaderHtml(additionalCookieMainGroups[cookieMainGroupKey].name, cookieGroups[cookieGroupKey].name, cookieMainGroupMandatory, false);
                    var cookieTableHtml = "";
                    var cookies = cookieGroups[cookieGroupKey].cookies;
                    for (var cookieKey in cookies) {
                        cookieTableHtml += generateCookieTableHtml(
                            additionalCookieMainGroups[cookieMainGroupKey].name,
                            cookieGroups[cookieGroupKey].name,
                            cookieKey,
                            cookies[cookieKey].description,
                            cookies[cookieKey].provider,
                            cookies[cookieKey].expiration,
                            cookieMainGroupMandatory,
                            false
                        );
                    }
                    cookieBodyHtml += '<div class="container--table">' + cookieGroupHeaderHtml + "<table>" + cookieTableHtml + "</table></div>";
                }
                additionalCookieHtml += "<div>" + cookieMainGroupHeaderHtml + cookieBodyHtml + "</div>";
            }
            document.getElementById("cookie-content").innerHTML = additionalCookieHtml + cookieHtml;
            var privacyLink = document.getElementById("privacyLink");

            document.getElementById("cookieBannerHint").style.setProperty("display", "block", "important");
            var cookieCollapsible = document.getElementsByClassName("cookie--collapsible");
            for (i = 0; i < cookieCollapsible.length; i++) {
                cookieCollapsible[i].addEventListener("click", function () {
                    this.classList.toggle("active");
                    document.getElementById("cookieBanner").classList.toggle("extended");
                    document.getElementById("cookieBanner").classList.toggle("collapsing");
                    setTimeout(function () {
                        document.getElementById("cookieBanner").classList.toggle("collapsing");
                    }, 500);
                    var content = this.nextElementSibling;
                    if (content.style.display === "block") {
                        content.setAttribute("style", "display: none !important");
                    } else {
                        content.setAttribute("style", "display: block !important");
                    }
                var cookieText = document.querySelector(".cookie--text");
                    var cookieTextButton = document.querySelector(".cookie--text-collapsible");
                    var cookieBanner = document.querySelector("#cookieBanner");
                    if (cookieBanner.classList.contains("cookie--banner-layout-2")) {
                        if (cookieBanner.classList.contains("extended")) {
                            cookieText.style.setProperty("max-height", cookieText.scrollHeight + "px", "important");
                            cookieText.parentElement.classList.add("transitioning");
                            cookieTextButton.setAttribute("style", "display: none !important");
                            setCookieInformationHeight();
                        } else {
                            cookieText.style.setProperty("max-height", "3em", "important");
                            cookieTextButton.setAttribute("style", "display: block !important");
                            cookieTextButton.classList.remove("active");
                            cookieTextButton.innerText = "mehr anzeigen";
                            setCookieBannerTop();
                        }
                    }
                });
            }
            function setCookieInformationHeight() {
                var cookieBanner = document.querySelector("#cookieBanner");
                if (!cookieBanner.classList.contains("cookie--banner-layout-2")) {
                    return;
                }
                var cookieOverlay = document.querySelector(".cookie--overlay");
                var top;
                if (window.innerWidth <= 768) {
                    top = 10;
                } else {
                    top = window.innerHeight * 0.1;
                }
                cookieOverlay.setAttribute("style", "top: " + top + "px !important");
                var cookieOverlayStyle = getComputedStyle(cookieOverlay);
                var paddingTop = parseInt(cookieOverlayStyle.paddingTop);
                var heading = cookieBanner.querySelector(".cookie--main-heading");
                var text = cookieBanner.querySelector(".cookie--text-container");
                var checkboxes = cookieBanner.querySelector(".container--checkboxes");
                var moreInformation = cookieBanner.querySelector(".cookie--collapsible");
                var buttonsEl = cookieBanner.querySelector(".cookie--buttons");
                var buttons = cookieOverlay.querySelector(".cookie--buttons");
                function calculateHeight() {
                    var heightCookieHeading = outerHeight(heading);
                    var heightCookieText = outerHeight(text);
                    var heightCookieCheckboxes = outerHeight(checkboxes);
                    var heightCookieMoreInformation = outerHeight(moreInformation);
                    var heightCookieButtons = outerHeight(buttonsEl);
                    var cookieContent = document.querySelector("#cookie-content");
                    var staticContentHeight = heightCookieHeading + heightCookieCheckboxes + heightCookieMoreInformation + heightCookieText + heightCookieButtons + 15;
                    var availableHeight = window.innerHeight - 2 * top - paddingTop;
                    var minCookieInformationHeight = window.innerHeight * 0.3;
                    var cookieInformationHeight = Math.max(availableHeight - staticContentHeight, minCookieInformationHeight);
                    cookieContent.style.height = cookieInformationHeight + "px";
                    var overlayHeight = outerHeight(cookieOverlay);
                    if (window.innerHeight > overlayHeight) {
                        buttons.classList.remove("position-fixed");
                        buttons.classList.add("position-absolute");
                    } else {
                        buttons.classList.remove("position-absolute");
                        buttons.classList.add("position-fixed");
                    }
                    if (top !== 10 && cookieInformationHeight === minCookieInformationHeight) {
                        buttons.style.setProperty("bottom", "auto", "important");
                        buttons.style.setProperty("padding-bottom", "15px", "important");
                    } else {
                        buttons.style.bottom = "";
                        buttons.style.setProperty("padding-bottom", "");
                    }
                    cookieOverlay.removeEventListener("transitionend", calculateHeight);
                    text.classList.remove("transitioning");
                }
                if (text.classList.contains("transitioning")) {
                    cookieOverlay.addEventListener("transitionend", calculateHeight);
                } else {
                    calculateHeight();
                }
            }
            function outerHeight(el) {
                var height = el.offsetHeight;
                var style = getComputedStyle(el);
                height += parseInt(style.marginTop) + parseInt(style.marginBottom);
                return height;
            }
            document.querySelector(".cookie--text-collapsible").addEventListener("click", function () {
                this.classList.toggle("active");
                var cookieText = document.querySelector(".cookie--text");
                if (this.classList.contains("active")) {
                    this.innerHTML = "weniger anzeigen";
                    cookieText.style.setProperty("max-height", cookieText.scrollHeight + "px", "important");
                    setCookieBannerTop();
                } else {
                    this.innerHTML = "mehr anzeigen";
                    cookieText.style.setProperty("max-height", "3em", "important");
                    setCookieBannerTop();
                }
            });
            window.addEventListener("resize", function () {
                if (document.querySelector("#cookieBanner").classList.contains("extended")) {
                    setCookieInformationHeight();
                } else {
                    setCookieBannerTop();
                }
            });
            document.addEventListener("change", function (e) {
                if (e.target.getAttribute("data-cookie-checkbox-top-group") === "true") {
                    var cookieMainGroupName = e.target.getAttribute("data-cookie-checkbox-top-group-name");
                    var checkboxes = document.querySelectorAll('[data-cookie-checkbox-top-group-name="' + cookieMainGroupName + '"]');
                    for (i = 0, n = checkboxes.length; i < n; i++) {
                        checkboxes[i].checked = e.target.checked;
                    }
                }
                if (e.target.getAttribute("data-cookie-checkbox-middle-group") === "true") {
                    var cookieMainGroupName = e.target.getAttribute("data-cookie-checkbox-top-group-name");
                    var cookieGroupName = e.target.getAttribute("data-cookie-checkbox-middle-group-name");
                    var checkboxes = document.querySelectorAll('[data-cookie-checkbox-low-group="true"][data-cookie-checkbox-middle-group-name="' + cookieGroupName + '"]');
                    for (i = 0, n = checkboxes.length; i < n; i++) {
                        checkboxes[i].checked = e.target.checked;
                    }
                    if (!e.target.checked) {
                        var checkboxes = document.querySelectorAll('[data-cookie-checkbox-top-group="true"][data-cookie-checkbox-top-group-name="' + cookieMainGroupName + '"]');
                        for (i = 0, n = checkboxes.length; i < n; i++) {
                            checkboxes[i].checked = e.target.checked;
                        }
                    } else {
                        checkWhetherAllCookieGroupsOfCookieMainGroupAreChecked(cookieMainGroupName);
                    }
                }
            });
            document.getElementById("btnCurrentCookies").addEventListener("click", function (e) {
                setCookieForCookieConfig();
                document.getElementById("cookieBanner").setAttribute("style", "display: none !important");
                document.getElementById("containerCookieBanner").setAttribute("style", "display: none !important");
                document.body.classList.remove("overflow-hidden");
            });
            document.getElementById("btnAllCookies").addEventListener("click", function (e) {
                handleBtnCheckAllCookies();
            });
            function setCookieBannerTop() {
                var cookieBanner = document.querySelector("#cookieBanner");
                if (!cookieBanner.classList.contains("cookie--banner-layout-2")) {
                    return;
                }
                if (!document.querySelector("#cookieBanner").classList.contains("extended")) {
                    var cookieOverlay = document.querySelector(".cookie--overlay");
                    var overlayStyle = getComputedStyle(cookieOverlay);
                    var padding = parseInt(overlayStyle.paddingTop) + parseInt(overlayStyle.paddingBottom);
                    var bottom = window.innerWidth <= 768 ? 0 : 80;
                    var mainHeadingHeight = outerHeight(document.querySelector(".cookie--main-heading"));
                    var cookieTextContainerHeight = outerHeight(document.querySelector(".cookie--text-container"));
                    var containerGroupsHeight = outerHeight(document.querySelector(".container--checkboxes"));
                    var cookieCollapsibleHeight = outerHeight(document.querySelector(".cookie--collapsible"));
                    var buttonsHeight = outerHeight(document.querySelector(".cookie--buttons"));
                    var totalHeight = mainHeadingHeight + cookieTextContainerHeight + containerGroupsHeight + cookieCollapsibleHeight + buttonsHeight + padding;
                    var newTop = Math.max(window.innerHeight - totalHeight - bottom, 10);
                    cookieOverlay.setAttribute("style", "top:" + newTop + "px !important");
                    var moreInformationButton = cookieOverlay.querySelector(".cookie--collapsible");
                    var informationRect = moreInformationButton.getBoundingClientRect();
                    var buttons = cookieOverlay.querySelector(".cookie--buttons");
                    var buttonsRect = buttons.getBoundingClientRect();
                    if (buttonsRect.top < informationRect.bottom) {
                        cookieOverlay.style.setProperty("padding-bottom", getComputedStyle(buttons).height, "important");
                    }
                }
            }
            document.getElementById("cookieBannerHint").addEventListener("click", function (e) {
                initialCheckDependingOnCookieConfig();
                document.getElementById("containerCookieBanner").setAttribute("style", "display: block !important");
                document.getElementById("cookieBanner").setAttribute("style", "display: block !important");
                document.body.classList.add("overflow-hidden");
                setCookieBannerTop();
            });
            initialCheckDependingOnCookieConfig();
            setCookieBannerTop();
            
        }
    },
    mounted() {
        if(document.getElementById("cookieBanner")){
            this.initiated = true;
        }

        if(!this.initiated && this.$root.whitelabel.setting('show_cookie_consent')) {
            this.handleScript()
        }
    }
}
</script>